import { render, staticRenderFns } from "./MainActivities.vue?vue&type=template&id=64219964&scoped=true&"
import script from "./MainActivities.vue?vue&type=script&lang=js&"
export * from "./MainActivities.vue?vue&type=script&lang=js&"
import style0 from "./MainActivities.vue?vue&type=style&index=0&id=64219964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64219964",
  null
  
)

export default component.exports